export default function PlayerPlatformsIndex() {
  return (
    <div className="prose">
      <h2>Supported Platforms</h2>
      <p>
        Q-Play player software can run on multiple platforms. Choose your platform from the list in the sidebar to
        view installation and configuration steps.
      </p>
      <ul>
        <li>Windows — Todo: installer, auto-start, codecs</li>
        <li>Linux — Todo: packages, services, hardware acceleration</li>
        <li>Samsung (Tizen) — Todo: app deployment, permissions, updates</li>
        <li>LG (WebOS) — Todo: app deployment, permissions, updates</li>
      </ul>
    </div>
  )
}
